import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CustomToastrService, ToastrMessageType, ToastrPosition } from 'app/base/services/custom-toast-service';
import { UnifiedAuthService } from 'app/services/yoklama/auth.service';
import { DeviceService } from 'app/services/yoklama/devices-services';


@Component({
  selector: 'app-device-management',
  templateUrl: './device-management.component.html',
  styleUrls: ['./device-management.component.css']
})
export class DeviceManagementComponent implements OnInit {

  deviceId: string | null = null;
  deviceCount: number = 0;
  isReturning = false;
isMobile=false;
  constructor(
    private deviceService: DeviceService,
    public router: Router,
    private loginService: UnifiedAuthService,
     public alertService: CustomToastrService,


  ) {}

  ngOnInit(): void {
    this.loadDevice();
  }

  // CİHAZ BİLGİSİ YÜKLE
  async loadDevice() {

    const id = await this.deviceService.getLocalDeviceId();
   const user = JSON.parse(localStorage.getItem('userList') || 'null');

    this.deviceId = id;

  //  console.log("📱 Cihaz ID'si yüklendi: ",  user?.data[0].deviceChangedCount);
    this.deviceCount = user?.data[0].deviceChangedCount ?? 1;
  }

  // CİHAZ SİL
  async deleteDevice() {
    const success = await this.deviceService.deleteDeviceId();

    if (success) {
      this.deviceId = null;
      this.alertService.message("Cihaz kaydı silindi.", "Bilgi", { messageType: ToastrMessageType.Info, position: ToastrPosition.TopFullWidth });
    } else {
      this.alertService.message("Cihaz silinirken hata oluştu.", "Hata", { messageType: ToastrMessageType.Error, position: ToastrPosition.TopFullWidth });
    }
  }

 addNewDevice() {
  const user = JSON.parse(localStorage.getItem('userList') || 'null');
  const userNo = user?.userNo?.toString() ?? '0';

  const newDeviceId = this.deviceService.generateDeviceId(userNo);

  this.router.navigate([
    '/device-verification',
    newDeviceId

  ]);
}
}
